<div class="example-container">

    <mat-toolbar id="appToolbar" color="primary" class="example-toolbar">
        <button mat-icon-button (click)="drawer.toggle()" i18n-matTooltip matTooltip="toogle sidebar">
            <mat-icon>menu</mat-icon>
        </button>
        <h1 id="appName" class="example-app-name">AssetDatabase</h1>
        <span class="demo-fill-remaining"></span>
        <h1 id="appTime" class="example-app-name">{{ date | date:'HH:mm' }}</h1>
        <span class="demo-fill-remaining"></span>
        <!-- <theme-picker></theme-picker> -->
        <p>{{authService.getUser().name}}</p>
        <mat-icon class="toolbar-icon" i18n-matTooltip matTooltip="Websocket State">
            {{printerState === 'Ready' ? 'print' : 'print_disabled'}}</mat-icon>
        <button mat-icon-button [mat-menu-trigger-for]="menu">
            <mat-icon>more_vert</mat-icon>
        </button>
    </mat-toolbar>
    <mat-menu x-position="before" #menu="matMenu">
        <button mat-menu-item routerLink="/login">
            <mat-icon>person</mat-icon>
            <span i18n="@@login">Login</span>
        </button>
        <button mat-menu-item (click)="authService.logout();">
            <mat-icon>person_outline</mat-icon>
            <span i18n="@@logout">Logout</span>
        </button>
        <mat-divider></mat-divider>
        <mat-divider></mat-divider>
        <button mat-menu-item routerLink="/account">
            <mat-icon>account_box</mat-icon>
            <span i18n="@@account">Account</span>
        </button>
        <button mat-menu-item routerLink="/roles">
            <mat-icon>supervisor_account</mat-icon>
            <span i18n="@@roles">Roles</span>
        </button>
        <button mat-menu-item routerLink="/settings">
            <mat-icon>settings</mat-icon>
            <span i18n="@@settings">Settings</span>
        </button>
    </mat-menu>

    <mat-sidenav-container class="sidenav-container" autosize>
        <mat-sidenav #drawer
            [ngClass]="{ 'sidenav-text': !isIconSidenav, 'sidenav-icon': isIconSidenav, 'sidenavStart': sidenav.position === 'start', 'sidenavEnd': sidenav.position === 'end' }"
            opened="true" mode="side" (openedChange)="sidenavChanged()" position="start">
            <mat-toolbar color="primary">
                <!-- <button type="button" aria-label="show toolbar" mat-icon-button (click)="toolbarVisible = !toolbarVisible;">
            <mat-icon aria-label="toolbar visible icon" *ngIf="!isIconSidenav">more_vert</mat-icon>
          </button> -->
                <ng-container *ngIf="!isIconSidenav">
                    <div >Menu</div>
                    <span class="demo-fill-remaining"></span>
                </ng-container>
                <div class="sidenav-reduce">
                <button type="button" aria-label="Reduce sidenav" mat-icon-button (click)="sidenavChangeType = true; drawer.close();">
                <mat-icon aria-label="Side nav reduce icon" *ngIf="!isIconSidenav">chevron_left</mat-icon>
                <mat-icon aria-label="Side nav reduce icon" *ngIf="isIconSidenav">chevron_right</mat-icon>
            </button>
            </div>
            </mat-toolbar>
            <app-sidenav-text *ngIf="!isIconSidenav"></app-sidenav-text>
            <app-sidenav-icon *ngIf="isIconSidenav"></app-sidenav-icon>
        </mat-sidenav>
        <mat-sidenav-content id="nav-content" #navContent>

            <!-- <app-welcome *ngIf="router.url === '/'"></app-welcome> -->

            <!-- <div [@routerTransition]="{value: router.url, params: { myWidth: '80%' }}"> -->
            <div [@routerTransition]="animationData()">
                <router-outlet></router-outlet>
            </div>
            <!-- <mat-toolbar color="primary"> -->
            <!-- <button type="button" aria-label="Toggle sidenav" mat-icon-button (click)="drawer.toggle()"> -->
            <!-- *ngIf="isHandset$ | async" -->
            <!-- <mat-icon aria-label="Side nav toggle icon">menu</mat-icon> -->
            <!-- </button> -->
            <!-- <span>Application Title</span> -->
            <!-- </mat-toolbar> -->
        </mat-sidenav-content>
    </mat-sidenav-container>

</div>